<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else paymentHistoryFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="paymentHistoryFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #paymentHistoryFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentHistoryMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="paymentHistoryMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #paymentHistoryMainFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <div fxFlex="90%" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else paymentHistoryHeaderFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="paymentHistoryHeaderFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else paymentHistoryOpenNotesTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="paymentHistoryOpenNotesTableFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column" class="primary-lightest-bg" *ngIf="selectedNoteId !== null && selectedNoteId > 0" id="noteDetails">
            <div *ngIf="isBrowserIE; else paymentHistoryNoteDetailFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="paymentHistoryNoteDetailFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else paymentHistoryScrollToTopFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
              <ng-container *ngTemplateOutlet="paymentHistoryScrollToTopFlexColumnTemplate"></ng-container>
            </div>
          </div>
          <div fxLayout="column" style="margin-top: 16px">
              <div *ngIf="isBrowserIE; else paymentHistoryNoticesFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentHistoryNoticesFlexColumnTemplate"></ng-container>
              </div>
          </div>

          </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #paymentHistoryHeaderFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
      <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
        <b>{{ userFullName }}</b>
      </span>
    </div>
    <div class="display-text primary-dark-color-important">
      <b
        ><span i18n="@@payment-history.header.participant-id.label">payment-history.header.participant-id.label</span>:&nbsp;{{
          participantIdString
        }}</b
      >
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px"></div>
  </div>
</ng-template>

<ng-template #paymentHistoryOpenNotesTableFlexColumnTemplate>
  <div fxLayout="column">
    <app-payment-history-list
      [participantId]="participantId"
      [displayTitle]="true"
      (selected)="onPaymentHistoryListSelected($event)"
    ></app-payment-history-list>
  </div>
  <div fxFlex="100%" style="margin-top: 16px"></div>
</ng-template>

<ng-template #paymentHistoryNoteDetailFlexColumnTemplate>
  <div fxFlex="100%" style="margin-top: 24px;"></div>
  <div fxFlex="100%" style="margin-left: 16px; margin-right: 16px;" class="display-text primary-dark-color-important">
    <b
      ><span i18n="@@payment-history.note-detail.note-id.label">payment-history.note-detail.note-id.label</span>:&nbsp;{{
        selectedNoteId
      }}</b
    >
  </div>
  <div fxFlex="100%" style="margin: 16px;" class="border-bottom-blue"></div>
  <div fxFlex="100%" style="margin-left: 16px; margin-right: 16px;">
    <app-note-payment-history-details-list
      [participantId]="participantId"
      [noteId]="selectedNoteId"
      (dataReturned)="onNotePaymentHistoryDetailsDataReturned($event)"
    ></app-note-payment-history-details-list>
  </div>
  <div fxFlex="100%" style="margin: 16px;"></div>
  <div fxFlex="100%" style="margin-left: 16px; margin-right: 16px;">
    <app-note-balance-adjustments-list
      [participantId]="participantId"
      [noteId]="selectedNoteId"
      (dataReturned)="onNoteBalanceAdjustmentsDataReturned($event)"
    ></app-note-balance-adjustments-list>
  </div>
  <div fxFlex="100%" style="margin: 16px;"></div>
  <div fxFlex="100%" style="margin-left: 16px; margin-right: 16px;">
    <app-note-total-amount-paid
      [participantId]="participantId"
      [noteId]="selectedNoteId"
      (dataReturned)="onNoteTotalAmountPaidDataReturned($event)"
    ></app-note-total-amount-paid>
  </div>
  <div fxFlex="100%" style="margin: 16px;"></div>
  <div fxFlex="100%" fxLayoutAlign="center center" style="margin-left: 16px; margin-right: 16px;" *ngIf="exportToExcelVisible()">
    <app-excel-export
      [disabled]="!exportDataAvailable"
      [fileName]="participantId.toString() + '_' + selectedNoteId.toString()"
      [appendDateTimeToFileName]="true"
      [dataToExport]="[this.notePaymentHistoryDetailsList, this.noteBalanceAdjustmentsList, this.noteTotalAmountPaid]"
      i18n-sheetNamesDelimitedString="@@payment-history.note-detail.export-to-excel.sheet-names"
      sheetNamesDelimitedString="payment-history.note-detail.export-to-excel.sheet-names"
      [columnsToExport]="[
        [
          'participantId',
          'noteId',
          'paymentDate',
          'paymentId',
          'paymentAmount',
          'principalAmountApplied',
          'interestAmountApplied',
          'feeAmount',
          'paymentType'
        ],
        [
          'participantId',
          'noteId',
          'adjustmentDate',
          'adjustmentId',
          'transactionAmount',
          'principalAmount',
          'interestAmount',
          'feeAmount',
          'adjustmentDescription'
        ],
        [
          'participantId',
          'noteId',
          'paymentType',
          'paymentAmount',
          'principalAmountApplied',
          'interestAmountApplied',
          'feeAmount'
        ]
      ]"
      i18n-columnLabelsDelimitedString="@@payment-history.note-detail.export-to-excel.column-labels"
      columnLabelsDelimitedString="payment-history.note-detail.export-to-excel.column-labels"
    ></app-excel-export>
  </div>
  <div fxFlex="100%" style="margin-top: 24px;"></div>
</ng-template>

<ng-template #paymentHistoryScrollToTopFlexColumnTemplate>
  <div fxLayout="column" *ngIf="selectedNoteId !== null">
    <div fxLayoutAlign="center center" style="margin-top: 24px;">
      <button mat-stroked-button color="primary" (click)="scrollToTop()" i18n="@@loan-details.list.go-to-top">
        loan-details.list.go-to-top
      </button>
    </div>
  </div>
</ng-template>
<!--<ng-template #paymentHistoryNoticesFlexColumnTemplate>
    <ng-container *ngIf="show">
        <div fxFlex="100%" class="display-text">
            <sup>*</sup>&nbsp;<b><span i18n="@@payment-history.notices.1">payment-history.notices.1</span></b>
          </div>
    </ng-container>
</ng-template>-->
